import { Component, HostListener, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '@env/environment';
import { FormService as FormLegacyService } from '@app/shared/services';
import { ID } from '@datorama/akita';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment, { MomentInput } from 'moment';

import { applyValues } from '@helpers/objects';
import { Form } from '@state/form';

export interface FormInfoModalData {
  form: Form;
  id: ID;
}
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-form-info-modal',
  styleUrls: ['./form-info-modal.component.scss'],
  templateUrl: './form-info-modal.component.html'
})
export class FormInfoModalComponent implements OnInit {
  form: Form;
  saving = false;

  formDetails: any;
  activities: any[];
  activeWorkflowCount = 0;
  templateWorkflowCount = 0;
  dataRequestCount = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: FormInfoModalData,
    private dialog: MatDialogRef<FormInfoModalComponent>,
    public formLegacyService: FormLegacyService
  ) {}

  ngOnInit() {
    applyValues({ data: this.data, keys: ['form'], obj: this });

    this.formDetails = [
      {
        header: 'Title',
        value: this.form.title
      },
      {
        header: 'Organization',
        type: 'href',
        url: this.organizationUrl(),
        value: this.form.organization ? this.form.organization.name : '-'
      },
      {
        header: 'Vehicle',
        type: this.vehicleUrl() ? 'href' : 'string',
        url: this.vehicleUrl(),
        value: this.form.vehicle ? this.form.vehicle.name : '-'
      },
      {
        header: 'Created at',
        value: this.formatDate(this.form.created_at)
      },
      {
        header: 'Updated at',
        value: this.formatDate(this.form.updated_at)
      },
      {
        header: 'Unlocked by',
        value: this.form.unlocked_by_user ? this.formatUser(this.form.unlocked_by_user) : '-'
      },
      {
        header: 'Unlocked at',
        value: this.form.unlocked_by_user ? this.formatDate(this.form.unlocked_at) : '-'
      },
      {
        header: 'Last Unlocked by',
        value: this.form.last_unlocked_by_user ? this.formatUser(this.form.last_unlocked_by_user) : '-'
      },
      {
        header: 'Last Unlocked at',
        value: this.form.last_unlocked_at ? this.formatDate(this.form.last_unlocked_at) : '-'
      }
    ];

    this.formLegacyService.getFormDetails(this.form.id, {
      success: (data) => {
        this.activeWorkflowCount = data.workflow_actionable_count;
        this.templateWorkflowCount = data.workflow_template_count;
        this.dataRequestCount = data.signature_request_count;
        this.activities = data.form_activities;
      }
    });
  }

  @HostListener('window:keyup.esc')
  close(): void {
    this.dialog.close();
  }

  form_activity_string(form_activity: any): string {
    let objectTypeString =
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      form_activity.object_type[0].toUpperCase() + form_activity.object_type.substring(1);
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    let typeString = form_activity.type[0].toUpperCase() + form_activity.type.substring(1);

    let string: string;
    let formActivityType: string = form_activity.type;
    if (['insert', 'edit'].includes(formActivityType)) {
      string = `${typeString}ed ${objectTypeString}`;
    } else if (form_activity.type === 'delete') {
      string = `${typeString}d ${objectTypeString}`;
    } else if (form_activity.type === 'move') {
      string = 'Form Moved';
    } else {
      string = `${objectTypeString} ${typeString} changed`;
    }

    if (['section, field, content'].includes(formActivityType)) {
      string += ` for `;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return string;
  }

  changed_properties_keys(changed_properties: object): string[] {
    return Object.keys(changed_properties);
  }

  organizationUrl(): string {
    if (!this.form.organization) return null;

    return `${environment.docsUrl}/e/${this.form.organization.entity_id}/entity/${this.form.organization.entity_id}`;
  }

  vehicleUrl(): string {
    if (!this.form.vehicle) return null;

    return `${environment.docsUrl}/e/${this.form.organization.entity_id}/fund/${this.form.vehicle.id}`;
  }

  formatUser(user: any): string {
    return `${user.full_name} <${user.email}>`;
  }

  formatDate(dateString: MomentInput): string {
    return moment(dateString).format('MMMM D, YYYY h:mm A');
  }
}
